<template>
  <div class="d-flex item-container" :class="{'item-container--warning' : hasErrors}">
    <ClosdFildersIcon :document="doc.file" />
    <span class="item-name text--small">
      {{ displayedDocumentName }}
    </span>
    <div class="item-status-container">
      <app-signature-status :status="doc.status" />
    </div>
  </div>
</template>

<script>
import ClosdFildersIcon from '@/common/filders/ClosdFildersIcon.vue'
import { ENVELOPE_TYPES } from '@/project/signing-checklist/constants'

export default {
  name: 'SigningChecklistSummaryListItem',
  components: { ClosdFildersIcon },
  props: {
    doc: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      ENVELOPE_TYPES,
    }
  },
  computed: {
    displayedDocumentName () {
      if (!this.multiEnvelopeSignatory) return this.doc.name
      return this.doc.name + ' - ' + this.multiEnvelopeSignatory.fullName
    },
    hasErrors () {
      return this.doc.missingToSend || this.doc.missingToSign
    },
    multiEnvelopeSignatory () {
      return this.doc.signatories?.flat().find(signatory => signatory.multiSignatureId !== null)
    },
  },
}
</script>

<style lang="scss" scoped>
  .item-container {
    background-color: rgb(var(--v-theme-surface-secondary));
    border-radius: 4px;
    margin-bottom: 16px;
    align-items: center;
    overflow: hidden;

    &--warning {
      background-color: rgb(var(--v-theme-surface-warning));
    }
  }
  .item-name {
    overflow: hidden;
    padding-right: 8px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .item-status-container {
    background-color: rgb(var(--v-theme-surface-tertiary));
    display: flex;
    justify-content: center;
    margin-left : auto;
    min-width: 150px;
    padding: 8px;

    .v-chip.v-size--default {
      height: auto;
      padding: 1px 12px;
    }
  }
  .item-status {
    color: white;
    font-size: 10px;
  }
</style>
